import { AiAgents, AiTeamsImpact, CaseStudies, Departments, MondayDifference, Products, Security, Trust, Closer, Logos, Hero } from "devlink";
export const DEVLINK_COMPONENT_MAP = new Map([
    [
        "Departments",
        Departments
    ],
    [
        "Products",
        Products
    ],
    [
        "AiTeamsImpact",
        AiTeamsImpact
    ],
    [
        "Trust",
        Trust
    ],
    [
        "Security",
        Security
    ],
    [
        "AiAgents",
        AiAgents
    ],
    [
        "CaseStudies",
        CaseStudies
    ],
    [
        "MondayDifference",
        MondayDifference
    ],
    [
        "Closer",
        Closer
    ],
    [
        "Logos",
        Logos
    ],
    [
        "Hero",
        Hero
    ]
]);
